// extracted by mini-css-extract-plugin
export var arrowHover = "dispatch-module--arrowHover--82e26";
export var container = "dispatch-module--container--e876d";
export var containerMore = "dispatch-module--containerMore--ed2b9";
export var content = "dispatch-module--content--35978";
export var icon = "dispatch-module--icon--561a5";
export var image = "dispatch-module--image--5ab73";
export var more = "dispatch-module--more--0ea94";
export var root = "dispatch-module--root--ada57";
export var title = "dispatch-module--title--60d76";